import api from '@/api/potential'

const state = {

}

const actions = {
  getCompanyPotentialCandidateList (context, params) {
    return api.getCompanyPotentialCandidateList(params)
  },
  getCandidateReferralChain (context, params) {
    return api.getCandidateReferralChain(params)
  },
  getPotentialCandidateIdList (context, params) {
    return api.getPotentialCandidateIdList(params)
  },
  getPotentialCandidateBaseInfo (context, { potentialId }) {
    return api.getPotentialCandidateBaseInfo(potentialId)
  },
  getPotentialCandidateResumeInfo (context, { potentialId }) {
    return api.getPotentialCandidateResumeInfo(potentialId)
  },
  getPotentialCandidateActivityInfo (context, { potentialId }) {
    return api.getPotentialCandidateActivityInfo(potentialId)
  },
  getPotentialCandidateTagInfo (context, params) {
    return api.getPotentialCandidateTagInfo(params)
  },
  getPotentialCandidateSurveyInfo (context, { potentialId }) {
    return api.getPotentialCandidateSurveyInfo(potentialId)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
